const getFaviconUrl = (data, domainBase) => {
  if (domainBase) {
    if (window.location.hostname.includes('vchost.co')) {
      return `${window.pov_config.VUE_APP_CLOUDINARY}favicons/development`;
    }
    const favName = window.location.hostname.replaceAll('-', '');
    return `${window.pov_config.VUE_APP_CLOUDINARY}favicons/${favName}`;
  }
  switch (data) {
    case 'development':
    case 'integration':
    case 'production':
      return `${window.pov_config.VUE_APP_POV_ASSETS_URL}images/favicons/favicon_${data}.png`;
    case 'star':
      return `${window.pov_config.VUE_APP_POV_ASSETS_URL}images/favicons/favicon_${data}.ico`;
    default:
      return `${window.pov_config.VUE_APP_POV_ASSETS_URL}images/favicons/favicon_generic.ico`;
  }
};

const handleFavicon = (data, domainBase) => {
  const faviconElement = document.getElementById('favicon');
  const faviconUrl = getFaviconUrl(data, domainBase);
  if (faviconElement && faviconUrl) {
    faviconElement.setAttribute('href', faviconUrl);
  }
};

export default {
  getFaviconUrl,
  handleFavicon,
};
